(function () {
  const ROOT_SELECTORS = [
    '.sidebar-mega-menu',
    '[data-sidebar-mega-menu]',
    '.header .mega-menu'
  ];

  function findRoot() {
    for (const sel of ROOT_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function getItemAnchor(target) {
    return target.closest('a, button');
  }

  function findPanelForItem(anchor) {
    const li = anchor.closest('li, .menu-item, .nav__item');
    if (!li) return null;

    let panel = li.querySelector('.sidebar-mega-menu__panel, .mega-menu__panel, .submenu, .sub-menu');
    if (panel) return panel;

    panel = li.nextElementSibling;
    if (panel && panel.querySelector && panel.querySelector('a')) return panel;

    const next = li.nextElementSibling;
    if (next) {
      const maybe = next.querySelector?.('.sidebar-mega-menu__panel, .mega-menu__panel, .submenu, .sub-menu');
      if (maybe) return maybe;
    }

    return null;
  }

  function wrapAsInline(panel) {
    if (panel.classList.contains('cc-inline-submenu')) return panel;

    panel.classList.add('cc-inline-submenu');
    panel.style.position = 'static';
    panel.style.inset = 'auto';
    panel.style.width = '100%';
    panel.style.boxShadow = 'none';

    return panel;
  }

  function closeOthers(root, exceptLi) {
    root.querySelectorAll('.cc-has-inline-open').forEach(li => {
      if (li !== exceptLi) li.classList.remove('cc-has-inline-open');
    });
  }

  function onInteract(e) {
    const root = findRoot();
    if (!root) return;
    if (!root.contains(e.target)) return;

    const a = getItemAnchor(e.target);
    if (!a) return;

    const li = a.closest('li, .menu-item, .nav__item');
    if (!li) return;

    const panel = findPanelForItem(a);
    if (!panel) return;
    if (!panel.querySelector('a')) return;

    if (e.type === 'click') {
      e.preventDefault();
    }

    const inlinePanel = wrapAsInline(panel);
    if (inlinePanel.parentElement !== li) {
      li.appendChild(inlinePanel);
    }

    const willOpen = !li.classList.contains('cc-has-inline-open');
    closeOthers(root, li);
    if (willOpen) li.classList.add('cc-has-inline-open');
    else li.classList.remove('cc-has-inline-open');
  }

  document.addEventListener('click', onInteract, true);

  document.addEventListener('mouseenter', function (e) {
    if (window.matchMedia('(hover: hover)').matches) onInteract(e);
  }, true);
})();